import { render, staticRenderFns } from "./StoredContents.vue?vue&type=template&id=f8e1c214&"
import script from "./StoredContents.vue?vue&type=script&lang=js&"
export * from "./StoredContents.vue?vue&type=script&lang=js&"
import style0 from "./StoredContents.vue?vue&type=style&index=0&id=f8e1c214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports